<!--
//================================================================================
// ID:BC061C3
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC061C3
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/09/30 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/09/26 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main contents__main--nyukyo">
		<error-message />
		<h2 class="contents__h2">{{ disp.chapter }}</h2>
		<section>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr class="contents__input--tr">
						<th class="contents__input--title border__bottom-none">
							氏名
						</th>
						<td class="border__bottom-none">
							<div id="contents--name__area">
								<div>
									氏：{{ enkakuchiFuyosyaForm.nmFuyoName1 }}
								</div>
								<div>
									名：{{ enkakuchiFuyosyaForm.nmFuyoName2 }}
								</div>
							</div>
						</td>
					</tr>
					<tr class="background__color--white">
						<th class="contents__input--title">
							フリガナ
						</th>
						<td>
							<div id="contents--name__area">
								<div>
									氏：{{ enkakuchiFuyosyaForm.nmFuyoKana1 }}
								</div>
								<div>
									名：{{ enkakuchiFuyosyaForm.nmFuyoKana2 }}
								</div>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">
							申込者との関係
						</th>
						<td class="padding__top">
							<div>
								{{ enkakuchiFuyosyaForm.nmMoukankei }}
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title">
							生年月日
						</th>
						<td class="padding__top">
							<div>
								{{ co_editDate(enkakuchiFuyosyaForm.dtBirthday) }}&nbsp;(満{{ co_calcAge(enkakuchiFuyosyaForm.dtBirthday) }}歳)
							</div>
							<div v-if="formC3.bosyuHoshiki == BOSYU_HOSHIKI.ZUIJI">
								<caution-message
									:tyuibunItems="disp.birthdayTyuiItems2"
									:visibilityFlg="disp.cautionMsgVisibilityFlg"
								/>
							</div>
							<div v-else>
								<caution-message
									:tyuibunItems="disp.birthdayTyuiItems"
									:visibilityFlg="disp.cautionMsgVisibilityFlg"
								/>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">特別控除</th>
						<td class="padding__top">
							<div class="height-kojto">
								<p class="p__multiple-row">
									{{ enkakuchiFuyosyaForm.nmKojto }}
								</p>
							</div>
							<caution-message
								:tyuibunItems="disp.kojtoItems"
								:visibilityFlg="disp.cautionMsgVisibilityFlg"
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</section>
		<section>
			<br/>
			<div id="contents__foot--button" class="contents__div--center margin__bottom-page">
				<div :class="[!disp.isPrevButton ? 'btn--prev-width' : '']" >
					<span v-if="disp.isPrevButton">
						<div id="btn--prev-pc">
							<input type="button" value="前の遠隔地扶養者" class="contents__btn--cancel btn--prev" tabindex="1" @click="prev" ref="backFuyo"/>
						</div>
					</span>
				</div>
				<div class="btn-toroku">
					<input type="button" value="戻る" class="contents__btn--cancel btn--complete btn--back-width" tabindex="2" @click="back" ref="back"/>
				</div>
				<div :class="[!disp.isNextButton ? 'btn--next-width' : '']" >
					<span v-if="disp.isNextButton">
						<div id="btn--next-pc">
							<input type="button" value="次の遠隔地扶養者" class="contents__btn--confirm btn--next" tabindex="3" @click="next"/>
						</div>
					</span>
				</div>
			</div>
			<br/>
		</section>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import CautionMessage from '@/components/CautionMessage.vue';

import { co_editDate, co_calcAge, co_commaSeparated, co_zenkaku2Hankaku } from '@/common/stringUtility.js';
import { co_toTop } from '@/common/screenUtility.js';
import { BOSYU_HOSHIKI } from '@/const/const.js';
import { STORE_ERROR_CLEAR, STORE_VIEW_TITLE } from '@/const/store.js'

export default {
	name: "BC061C3",
	components: {
		'error-message': ErrorMessage,
		'caution-message' : CautionMessage,
	},
	props: ['form'],
	data: function () {
		return {
			enkakuchiFuyosyaForm: {
				noFuyo: 0,		    // 遠隔地扶養者番号
				nmFuyoName1: '',	// 氏名（氏）
				nmFuyoName2: '',	// 氏名（名）
				nmFuyoKana1: '',	// フリガナ（氏）
				nmFuyoKana2: '',	// フリガナ（名）
				cdMoukankei: '',	// 続柄
				nmMoukankei: '',	// 続柄（名称）
				dtBirthday: '',		// 生年月日
				fgKojto: '',		// 特別控除
				nmKojto: '',		// 特別控除（名称）
				isInputCheck:false,	// 入力チェック結果
			},
			disp: {
				chapter: '',					// 見出し
				birthdayTyuiItems: ['C0191'],	// 遠隔地扶養者年齢注意文リスト
				birthdayTyuiItems2: ['C0223'],	// 遠隔地扶養者年齢注意文リスト2
				syotokuItems: ['C0034'],		// 年間所得注意文リスト
				kojtoItems: ['C0187'],			// 特別控除注意文リスト
				isPrevButton: true,				// 前の遠隔地扶養者ボタン表示フラグ
				isNextButton: true,				// 次の遠隔地扶養者ボタン表示フラグ
				navList: [],					// ナビゲーションリスト
				cautionMsgVisibilityFlg: true,	// 注意文表示フラグ
			},
			formC3: [],		// 入力FORM
			co_editDate: co_editDate,
			co_calcAge: co_calcAge,
			co_commaSeparated: co_commaSeparated,
			BOSYU_HOSHIKI: BOSYU_HOSHIKI
		}
	},
	mounted: async function () {
		await this.$nextTick();
		
		let noFuyo = this.$route.params.noFuyo;
		if (noFuyo == 1) {
			// フォーカス設定
			this.$refs.back.focus();
		} else {
			// フォーカス設定
			this.$refs.backFuyo.focus();
		}

		// ページトップへ遷移
		co_toTop();
	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// 画面タイトル
		this.$store.commit(STORE_VIEW_TITLE, '遠隔地扶養者内容確認（管理者用）');

		// 画面項目設定
		this.formC3 = this.form;
		let noFuyo = Number(this.$route.params.noFuyo);
		this.drawEnkakuchiFuyosyaInfo(noFuyo);

		if (this.formC3.refChangebtn == "参照") {
			this.disp.cautionMsgVisibilityFlg = false;
		} else {
			this.disp.cautionMsgVisibilityFlg = true;
		}
	},
	methods: {
		// 遠隔地扶養者情報設定
		drawEnkakuchiFuyosyaInfo: async function (noFuyo) {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 画面項目設定
			let fuyoInfo = this.formC3.fuyoList[noFuyo-1];
			
			this.enkakuchiFuyosyaForm = fuyoInfo;
			this.enkakuchiFuyosyaForm.noFuyo = noFuyo;

			this.disp.chapter = '遠隔地扶養者情報（' + co_zenkaku2Hankaku(noFuyo) + '人目）';

			if (noFuyo == 1) {
				// 先頭遠隔地扶養者の場合、前の遠隔地扶養者ボタンを表示しない
				this.disp.isPrevButton = false;
			} else {
				this.disp.isPrevButton = true;
			}

			if (noFuyo == this.formC3.fuyoList.length) {
				// 最終遠隔地扶養者の場合、次の遠隔地扶養者ボタンを表示しない
				this.disp.isNextButton = false;
			} else {
				this.disp.isNextButton = true;
			}

			// ページトップへ遷移
			co_toTop();
		},
		// 前の遠隔地扶養者ボタン
		prev: async function () {

			// 遠隔地扶養者内容確認画面（前の遠隔地扶養者）に遷移
			this.drawEnkakuchiFuyosyaInfo(this.enkakuchiFuyosyaForm.noFuyo - 1);
		},
		// 戻るボタン
		back: function () {
			
			// 申込み内容確認画面に遷移
			this.$emit('back');
		},
		// 次の遠隔地扶養者ボタン
		next: async function () {

			// 遠隔地扶養者内容確認画面（次の遠隔地扶養者）に遷移
			this.drawEnkakuchiFuyosyaInfo(this.enkakuchiFuyosyaForm.noFuyo + 1);

		}
	}
};
</script>

<style scoped>

th {
	margin-bottom: -18px;
}

.contents__main--nyukyo {
	margin-top: 80px !important;
}

/* フッターボタン */
#contents__foot--button {
	display: flex;
	flex-direction: row;
}
#contents__foot--button :nth-child(1) {
	order: 1;
	text-align: left;
}
#contents__foot--button :nth-child(2) {
	order: 2;
	margin: auto;
	text-align: center;
}
#contents__foot--button :nth-child(3) {
	order: 3;
	text-align: right;
}

.btn--prev-width,
.btn--next-width {
	width: 8%;
}

.padding__top {
	padding-top: 10px !important;
}

.height-kojto {
	margin-top: 10px;
}

</style>